import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 14px;\n  cursor: pointer;\n  padding: 7px;\n  margin-bottom: 2px;\n  border-radius: 4px;\n  font-size: ', ';\n  ', '\n  ', '\n  ', '\n  ', '\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 14px;\n  cursor: pointer;\n  padding: 7px;\n  margin-bottom: 2px;\n  border-radius: 4px;\n  font-size: ', ';\n  ', '\n  ', '\n  ', '\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      background-color: ', ';\n      @media only screen and (max-width: 944) {\n        background-color: transparent;\n      }\n    '], ['\n      background-color: ', ';\n      @media only screen and (max-width: 944) {\n        background-color: transparent;\n      }\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      &:hover {\n        background-color: ', ';\n        .reviewer {\n          display: flex;\n        }\n      }\n    '], ['\n      &:hover {\n        background-color: ', ';\n        .reviewer {\n          display: flex;\n        }\n      }\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      .reviewer {\n        display: flex;\n      }\n    '], ['\n      .reviewer {\n        display: flex;\n      }\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      cursor: not-allowed;\n      opacity: 0.4;\n    '], ['\n      cursor: not-allowed;\n      opacity: 0.4;\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  margin-right: ', ';\n'], ['\n  margin-right: ', ';\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ', ';\n  opacity: 0.5;\n  border-radius: 45%;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ', ';\n  opacity: 0.5;\n  border-radius: 45%;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  position: absolute;\n  right: -2px;\n  bottom: -4px;\n  width: 14px;\n  height: 14px;\n  padding: 1px;\n  background-color: white;\n  border-radius: 50%;\n'], ['\n  position: absolute;\n  right: -2px;\n  bottom: -4px;\n  width: 14px;\n  height: 14px;\n  padding: 1px;\n  background-color: white;\n  border-radius: 50%;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  flex-shrink: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  width: 100%;\n  line-height: 18px;\n'], ['\n  flex-shrink: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  width: 100%;\n  line-height: 18px;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  color: ', ';\n  ', '\n  text-overflow: ellipsis;\n  overflow: hidden;\n'], ['\n  color: ', ';\n  ', '\n  text-overflow: ellipsis;\n  overflow: hidden;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  color: ', ';\n  text-overflow: ellipsis;\n  overflow: hidden;\n'], ['\n  color: ', ';\n  text-overflow: ellipsis;\n  overflow: hidden;\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'], ['\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  line-height: 18px;\n  font-size: ', ';\n  font-weight: 500;\n  float: right;\n  display: none;\n  flex-direction: row-reverse;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  color: ', ';\n  &:hover svg,\n  &:hover path {\n    fill: ', ';\n  }\n'], ['\n  line-height: 18px;\n  font-size: ', ';\n  font-weight: 500;\n  float: right;\n  display: none;\n  flex-direction: row-reverse;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  color: ', ';\n  &:hover svg,\n  &:hover path {\n    fill: ', ';\n  }\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n  &:hover ~ .add-reviewer {\n    display: block;\n  }\n'], ['\n  &:hover ~ .add-reviewer {\n    display: block;\n  }\n']),
    _templateObject15 = _taggedTemplateLiteral(['\n  margin-right: 4px;\n  display: none;\n'], ['\n  margin-right: 4px;\n  display: none;\n']);

import React from 'react';
import styled, { css } from 'styled-components';
import { Icon, UserPicture } from './..';
import { styles } from 'gipsy-misc';
/* babel-plugin-inline-import '../assets/gipsyeye.svg' */var gipsyeye = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTc5cHgiIGhlaWdodD0iMTc4cHgiIHZpZXdCb3g9IjAgMCAxNzkgMTc4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1MC4yICg1NTA0NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAiIGZpbGw9IiMyMTE1NTEiPgogICAgICAgICAgICA8cGF0aCBkPSJNODkuMzksMCBDNDAuMSwwIDAsMzkuOSAwLDg4Ljk1IEMwLDEzOCA0MC4xLDE3Ny45NSA4OS4zOSwxNzcuOTUgQzEzOC42OCwxNzcuOTUgMTc4Ljc4LDEzOC4wNCAxNzguNzgsODguOTUgQzE3OC43OCwzOS44NiAxMzguNjgsMCA4OS4zOSwwIE04OS4zOSwxNTguMjIgQzUxLjAxLDE1OC4yMiAxOS43OCwxMjcuMTQgMTkuNzgsODguOTUgQzE5Ljc4LDUwLjc2IDUxLjAxLDE5LjY4IDg5LjM5LDE5LjY4IEMxMjcuNzcsMTkuNjggMTU5LDUwLjc2IDE1OSw4OC45NSBDMTU5LDEyNy4xNCAxMjcuNzcsMTU4LjIyIDg5LjM5LDE1OC4yMiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMjcuNDAwNTgyLDg5LjMwMDcyOTUgQzExNi44ODcwNTksODkuMzg2MDI0NCAxMDcuNDcyNzk4LDgyLjgwMzk1NjUgMTAzLjk0MzE3LDcyLjkwMDI2MjEgQzEwMC40MTM1NDIsNjIuOTk2NTY3NiAxMDMuNTQyOTEsNTEuOTQ0MDEyNSAxMTEuNzQwNTgyLDQ1LjM2MDcyOTUgQzkyLjAzMjk2NDQsMzUuMzQzNzYxNiA2OC4wNjg2ODY4LDM5LjY0OTEyMDkgNTMuMDgwMTkyNSw1NS44OTk1MDE1IEMzOC4wOTE2OTgyLDcyLjE0OTg4MiAzNS43MzMyNzQsOTYuMzgzMzQxNCA0Ny4zMDcxNzk1LDExNS4yMTg4MDEgQzU4Ljg4MTA4NSwxMzQuMDU0MjYxIDgxLjU2NTUzMTQsMTQyLjg5OTUyIDEwMi44MzQ3NjQsMTM2Ljg3MDQ2IEMxMjQuMTAzOTk3LDEzMC44NDEzOTkgMTM4Ljc3MjQ0NywxMTEuNDA3OTQxIDEzOC43NDA1ODIsODkuMzAwNzI5NSBDMTM4Ljc0MDU4Miw4OC4zOTA3Mjk1IDEzOC42NTA1ODIsODcuNTEwNzI5NSAxMzguNjAwNTgyLDg2LjYyMDcyOTUgQzEzNS4xMjkyNTUsODguMzgwNTA0NiAxMzEuMjkyNDg2LDg5LjI5ODU4ODcgMTI3LjQwMDU4Miw4OS4zMDA3Mjk1IiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==';


export default (function (_ref) {
  var user = _ref.user,
      disabled = _ref.disabled,
      preSelected = _ref.preSelected,
      onSelect = _ref.onSelect,
      selected = _ref.selected,
      isReviewer = _ref.isReviewer,
      name = _ref.name,
      showStar = _ref.showStar,
      _ref$preSelectedBackg = _ref.preSelectedBackgroundColor,
      preSelectedBackgroundColor = _ref$preSelectedBackg === undefined ? 'white' : _ref$preSelectedBackg;

  return React.createElement(
    SuggestionContainer,
    {
      className: 'suggestion',
      onClick: !disabled ? onSelect : null,
      disabled: disabled,
      preSelected: preSelected,
      preSelectedBackgroundColor: preSelectedBackgroundColor,
      selected: selected,
      isReviewer: isReviewer },
    React.createElement(
      StyledUserPicture,
      {
        src: user && user.picture,
        iconColor: selected ? 'white' : undefined,
        borderRadius: '45%',
        showDefaultIcon: !selected,
        backgroundColor: selected ? styles.colors.primaryColor : '#e3e5e6' },
      selected && React.createElement(SelectedOverlay, null),
      user && user.userId && React.createElement(GipsyEye, { src: gipsyeye, className: 'gipsyeye' }),
      selected && React.createElement(
        Selected,
        null,
        React.createElement(Icon, { icon: 'Checked', size: 16, fill: 'white' })
      )
    ),
    React.createElement(
      Info,
      null,
      React.createElement(
        Name,
        { selected: selected },
        user ? user.displayName || user.email : name
      ),
      user && user.email && user.displayName && React.createElement(
        Email,
        null,
        '' + user.email,
        user.userId && ' - ',
        user.userId ? 'Gipsybot user' : ''
      )
    ),
    !disabled && showStar && React.createElement(
      Reviewer,
      { className: 'reviewer' },
      React.createElement(ReviewerStar, { icon: 'Star', size: 16, fill: isReviewer ? styles.colors.primaryColor : undefined })
    )
  );
});

var SuggestionContainer = styled.div(_templateObject, styles.fonts.fontSizeSmall, function (props) {
  return !props.disabled && props.preSelected && css(_templateObject2, props.preSelectedBackgroundColor);
}, function (props) {
  return !props.disabled && css(_templateObject3, props.preSelectedBackgroundColor);
}, function (props) {
  return (props.selected || props.isReviewer) && css(_templateObject4);
}, function (props) {
  return props.disabled && css(_templateObject5);
});

var StyledUserPicture = styled(UserPicture)(_templateObject6, styles.spacings.small);

var SelectedOverlay = styled.div(_templateObject7, styles.colors.primaryColor);

var GipsyEye = styled.img(_templateObject8);

var Info = styled.div(_templateObject9);

var Name = styled.div(_templateObject10, function (props) {
  return props.selected ? styles.colors.primaryColor : styles.colors.textDarkColor;
}, function (props) {
  return props.selected && 'font-weight: 500';
});

var Email = styled.div(_templateObject11, styles.colors.textLightColor);

var Selected = styled.div(_templateObject12);

var Reviewer = styled.div(_templateObject13, styles.fonts.fontSizeXSmall, styles.colors.primaryColor, styles.colors.primaryColor);

var ReviewerStar = styled(Icon)(_templateObject14);

var ReviewerAddLabel = styled.div(_templateObject15);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/UserSuggestion/index.js
// module id = 1138
// module chunks = 0